/*eslint-disable react/no-danger*/
import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';

import ReferralForm from './ReferralForm';

import * as actions from 'actions';
import { getF2F } from 'selectors';
import NoEntries from 'components/NoEntries';
import NoEntriesDetail from 'components/NoEntries/NoEntriesDetail';

class Referral extends Component {

  componentDidMount() {
    if (this.props.onDidMount) {
      this.props.onDidMount();
    }
  }

  render() {
    return (
      <section className="content-wrapper has-background-medium">
        <div className="wrapper-small">
          <h1>{__('members.faceToFace.title')}</h1>

          {(() => {
            if(this.props.isF2FAvailable) {
              return <ReferralForm />;
            }
            else if (this.props.isFetching) {
              return (
                <div className="while-loading">
                  <h3>{__('members.faceToFace.loading')}</h3>
                </div>
              );
            }
            else if(!this.props.isF2FAvailable) {
              const link = "incrisis.html";
              return (
                <NoEntries title={__('members.faceToFace.notAvailable.title')}>
                  <NoEntriesDetail>{__('members.faceToFace.notAvailable.subtitle')}</NoEntriesDetail>
                  <p dangerouslySetInnerHTML={{ __html: `In crisis? Then click <a class='Link' href=${link} target='_blank'>here</a> for some services that can help you.` }} />
                </NoEntries>
              );
            }
          })()}
        </div>
      </section>
    );
  }
}

Referral.propTypes = {
  onDidMount: PropTypes.func,
  isF2FAvailable: PropTypes.bool,
  isFetching: PropTypes.bool
};

const mapStateToProps = (state) => {
  return {
    isF2FAvailable: getF2F(state).isAvailable,
    isFetching: getF2F(state).isFetching
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onDidMount: () => {
      dispatch(actions.f2fStatusFetch());
    }
  };
};


export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Referral);



/** WEBPACK FOOTER **
 ** ./src/members/Main/Referral/index.js
 **/